import { createAction, handleActions } from 'redux-actions'

const openSubOrderModal = createAction('SCREENS/ORDER_VIEW/OPEN_SUB_ORDER_MODAL')
const closeSubOrderModal = createAction('SCREENS/ORDER_VIEW/CLOSE_SUB_ORDER_MODAL')

const defaultState = {
  show: false,
  project: null,
  orderItemIds: [],
  orderTotal: null,
}

const reducer = handleActions(
  {
    [openSubOrderModal]: (state, { payload }) => ({
      ...payload,
      show: true,
    }),
    [closeSubOrderModal]: () => defaultState,
  },
  defaultState,
)

export { openSubOrderModal, closeSubOrderModal, reducer }
